import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import colors from '../../../styles/export.module.scss.js';
import Button from '../../../components/Button/Button.js';
import '../../../components/AppLogo/AppLogo.js';
import '../../../components/Avatar/Avatar.js';
import '../../../components/Input/Input.js';
import '../../../components/Input/PasswordInput.js';
import '../../../components/Icon/Icon.js';
import '../../../components/Image/Image.js';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner.js';
import '../../../components/Note/Note.js';
import '../../../components/RadioButton/RadioButton.js';
import '../../../components/RoundButton/RoundButton.js';
import '../../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../../components/Expandable/Expandable.js';
import '../../../components/PopOver/PopOver.js';
import '../../../components/Wizard/Wizard.js';
import '../../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../../components/ToggleButton/ToggleButton.js';
import '../../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../../components/Checkbox/Checkbox.js';
import '../../../components/SelectionField/SelectionField.js';
import '../../../components/Card/Card.js';
import '../../../components/Badge/Badge.js';
import '../../../components/SettingsItem/SettingsItem.js';
import '../../../components/SortableList/SortableList.js';
import '../../../components/Contacts/ContactItem.js';
import '../../../components/TopElement/TopElement.js';
import '../../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'classnames';
import 'react-i18next';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../i18n/i18n.js';
import '../../../components/Flag/Flag.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import '../../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../../components/Carousel/ImageCarousel.module.scss.js';
import { state } from '../UseRssi/useRssi.js';
import styles from './RssiStatus.module.scss.js';
import { RssiItem } from './RssiItem.js';

var RssiStatus = function RssiStatus(_ref) {
  var t = _ref.t,
    rssiState = _ref.rssiState,
    startRssiScan = _ref.startRssiScan,
    stopRssiScan = _ref.stopRssiScan;
  var RETRY = state.RETRY,
    POLLING = state.POLLING,
    TOO_LOW = state.TOO_LOW,
    TOO_HIGH = state.TOO_HIGH,
    OK = state.OK,
    ERROR = state.ERROR,
    NULL = state.NULL;
  var _useState = useState(RETRY),
    _useState2 = _slicedToArray(_useState, 2),
    prevState = _useState2[0],
    setPrevState = _useState2[1];
  useEffect(function () {
    if (rssiState === TOO_LOW) {
      setPrevState(TOO_LOW);
    }
    if (rssiState === TOO_HIGH) {
      setPrevState(TOO_HIGH);
    }
  }, [rssiState, TOO_LOW, TOO_HIGH]);
  var retryButton = /*#__PURE__*/React.createElement(Button, {
    dataTestId: "retry-scan",
    className: styles.cancelScanButton,
    text: t('MPLIB_RSSI_RETRY_SCAN'),
    onClick: startRssiScan
  });
  var stopButton = /*#__PURE__*/React.createElement(Button, {
    dataTestId: "stop-scan",
    className: styles.cancelScanButton,
    text: t('MPLIB_RSSI_STOP_SCAN'),
    onClick: stopRssiScan,
    isLoading: true
  });
  switch (rssiState) {
    case POLLING:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles.rssiItem
      }, /*#__PURE__*/React.createElement(LoadingSpinner, {
        dataTestId: "polling-spinner-rssi",
        relative: true,
        isLoading: true,
        centered: true,
        size: "medium",
        className: styles.spinner
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.rssiTitle
      }, t('MPLIB_CHECKING_FOR_ERRORS')), /*#__PURE__*/React.createElement("div", {
        className: styles.text
      }, t('MPLIB_POLLING_RSSI'))));
    case TOO_LOW:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-wifi-2',
          color: colors.tangerine
        },
        title: t('MPLIB_RSSI_BAD_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_BAD_SIGNAL_DESCRIPTION'),
        dataTestId: "signal-low"
      }), /*#__PURE__*/React.createElement("section", {
        className: styles.cancelScan
      }, stopButton));
    case TOO_HIGH:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-wifi',
          color: colors.red
        },
        title: t('MPLIB_RSSI_TOO_HIGH_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_TOO_HIGH_SIGNAL_DESCRIPTION'),
        dataTestId: "signal-too-high"
      }), /*#__PURE__*/React.createElement("section", {
        className: styles.cancelScan
      }, stopButton));
    case OK:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-wifi',
          color: colors.green
        },
        title: t('MPLIB_RSSI_GOOD_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_GOOD_SIGNAL_DESCRIPTION'),
        dataTestId: "signal-good"
      }));
    case RETRY:
      return /*#__PURE__*/React.createElement(React.Fragment, null, prevState === RETRY && /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-failed',
          color: colors.darkred
        },
        title: t('MPLIB_RSSI_NO_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_NO_SIGNAL_TIMEOUT'),
        dataTestId: "signal-none-timeout"
      }), prevState === TOO_LOW && /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-wifi-2',
          color: colors.tangerine
        },
        title: t('MPLIB_RSSI_BAD_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_BAD_SIGNAL_DESCRIPTION'),
        dataTestId: "signal-low"
      }), prevState === TOO_HIGH && /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-wifi',
          color: colors.red
        },
        title: t('MPLIB_RSSI_TOO_HIGH_SIGNAL_TITLE'),
        description: t('MPLIB_RSSI_TOO_HIGH_SIGNAL_DESCRIPTION'),
        dataTestId: "signal-too-high"
      }), /*#__PURE__*/React.createElement("section", {
        className: styles.cancelScan
      }, retryButton));
    case ERROR:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RssiItem, {
        iconInfo: {
          icon: 'icon-failed',
          color: colors.red
        },
        title: t('MPLIB_RSSI_NO_SIGNAL_TITLE'),
        dataTestId: "signal-none-timeout"
      }), /*#__PURE__*/React.createElement("section", {
        className: styles.cancelScan
      }, retryButton));
    case NULL:
    default:
      return null;
  }
};
RssiStatus.propTypes = {
  t: PropTypes.func.isRequired,
  rssiState: PropTypes.string.isRequired,
  startRssiScan: PropTypes.func.isRequired,
  stopRssiScan: PropTypes.func.isRequired
};
RssiStatus.defaultProps = {};

export { RssiStatus };
